import { __extends } from "tslib";
import { Observable } from "../Misc/observable";
import { Gamepad } from "../Gamepads/gamepad";
/**
 * Defines supported buttons for XBox360 compatible gamepads
 */
export var Xbox360Button;
(function (Xbox360Button) {
    /** A */
    Xbox360Button[Xbox360Button["A"] = 0] = "A";
    /** B */
    Xbox360Button[Xbox360Button["B"] = 1] = "B";
    /** X */
    Xbox360Button[Xbox360Button["X"] = 2] = "X";
    /** Y */
    Xbox360Button[Xbox360Button["Y"] = 3] = "Y";
    /** Left button */
    Xbox360Button[Xbox360Button["LB"] = 4] = "LB";
    /** Right button */
    Xbox360Button[Xbox360Button["RB"] = 5] = "RB";
    /** Back */
    Xbox360Button[Xbox360Button["Back"] = 8] = "Back";
    /** Start */
    Xbox360Button[Xbox360Button["Start"] = 9] = "Start";
    /** Left stick */
    Xbox360Button[Xbox360Button["LeftStick"] = 10] = "LeftStick";
    /** Right stick */
    Xbox360Button[Xbox360Button["RightStick"] = 11] = "RightStick";
})(Xbox360Button || (Xbox360Button = {}));
/** Defines values for XBox360 DPad  */
export var Xbox360Dpad;
(function (Xbox360Dpad) {
    /** Up */
    Xbox360Dpad[Xbox360Dpad["Up"] = 12] = "Up";
    /** Down */
    Xbox360Dpad[Xbox360Dpad["Down"] = 13] = "Down";
    /** Left */
    Xbox360Dpad[Xbox360Dpad["Left"] = 14] = "Left";
    /** Right */
    Xbox360Dpad[Xbox360Dpad["Right"] = 15] = "Right";
})(Xbox360Dpad || (Xbox360Dpad = {}));
/**
 * Defines a XBox360 gamepad
 */
var Xbox360Pad = /** @class */ (function (_super) {
    __extends(Xbox360Pad, _super);
    /**
     * Creates a new XBox360 gamepad object
     * @param id defines the id of this gamepad
     * @param index defines its index
     * @param gamepad defines the internal HTML gamepad object
     * @param xboxOne defines if it is a XBox One gamepad
     */
    function Xbox360Pad(id, index, gamepad, xboxOne) {
        if (xboxOne === void 0) { xboxOne = false; }
        var _this = _super.call(this, id, index, gamepad, 0, 1, 2, 3) || this;
        _this._leftTrigger = 0;
        _this._rightTrigger = 0;
        /** Observable raised when a button is pressed */
        _this.onButtonDownObservable = new Observable();
        /** Observable raised when a button is released */
        _this.onButtonUpObservable = new Observable();
        /** Observable raised when a pad is pressed */
        _this.onPadDownObservable = new Observable();
        /** Observable raised when a pad is released */
        _this.onPadUpObservable = new Observable();
        _this._buttonA = 0;
        _this._buttonB = 0;
        _this._buttonX = 0;
        _this._buttonY = 0;
        _this._buttonBack = 0;
        _this._buttonStart = 0;
        _this._buttonLB = 0;
        _this._buttonRB = 0;
        _this._buttonLeftStick = 0;
        _this._buttonRightStick = 0;
        _this._dPadUp = 0;
        _this._dPadDown = 0;
        _this._dPadLeft = 0;
        _this._dPadRight = 0;
        _this._isXboxOnePad = false;
        _this.type = Gamepad.XBOX;
        _this._isXboxOnePad = xboxOne;
        return _this;
    }
    /**
     * Defines the callback to call when left trigger is pressed
     * @param callback defines the callback to use
     */
    Xbox360Pad.prototype.onlefttriggerchanged = function (callback) {
        this._onlefttriggerchanged = callback;
    };
    /**
     * Defines the callback to call when right trigger is pressed
     * @param callback defines the callback to use
     */
    Xbox360Pad.prototype.onrighttriggerchanged = function (callback) {
        this._onrighttriggerchanged = callback;
    };
    Object.defineProperty(Xbox360Pad.prototype, "leftTrigger", {
        /**
         * Gets the left trigger value
         */
        get: function () {
            return this._leftTrigger;
        },
        /**
         * Sets the left trigger value
         */
        set: function (newValue) {
            if (this._onlefttriggerchanged && this._leftTrigger !== newValue) {
                this._onlefttriggerchanged(newValue);
            }
            this._leftTrigger = newValue;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Xbox360Pad.prototype, "rightTrigger", {
        /**
         * Gets the right trigger value
         */
        get: function () {
            return this._rightTrigger;
        },
        /**
         * Sets the right trigger value
         */
        set: function (newValue) {
            if (this._onrighttriggerchanged && this._rightTrigger !== newValue) {
                this._onrighttriggerchanged(newValue);
            }
            this._rightTrigger = newValue;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Defines the callback to call when a button is pressed
     * @param callback defines the callback to use
     */
    Xbox360Pad.prototype.onbuttondown = function (callback) {
        this._onbuttondown = callback;
    };
    /**
     * Defines the callback to call when a button is released
     * @param callback defines the callback to use
     */
    Xbox360Pad.prototype.onbuttonup = function (callback) {
        this._onbuttonup = callback;
    };
    /**
     * Defines the callback to call when a pad is pressed
     * @param callback defines the callback to use
     */
    Xbox360Pad.prototype.ondpaddown = function (callback) {
        this._ondpaddown = callback;
    };
    /**
     * Defines the callback to call when a pad is released
     * @param callback defines the callback to use
     */
    Xbox360Pad.prototype.ondpadup = function (callback) {
        this._ondpadup = callback;
    };
    Xbox360Pad.prototype._setButtonValue = function (newValue, currentValue, buttonType) {
        if (newValue !== currentValue) {
            if (newValue === 1) {
                if (this._onbuttondown) {
                    this._onbuttondown(buttonType);
                }
                this.onButtonDownObservable.notifyObservers(buttonType);
            }
            if (newValue === 0) {
                if (this._onbuttonup) {
                    this._onbuttonup(buttonType);
                }
                this.onButtonUpObservable.notifyObservers(buttonType);
            }
        }
        return newValue;
    };
    Xbox360Pad.prototype._setDPadValue = function (newValue, currentValue, buttonType) {
        if (newValue !== currentValue) {
            if (newValue === 1) {
                if (this._ondpaddown) {
                    this._ondpaddown(buttonType);
                }
                this.onPadDownObservable.notifyObservers(buttonType);
            }
            if (newValue === 0) {
                if (this._ondpadup) {
                    this._ondpadup(buttonType);
                }
                this.onPadUpObservable.notifyObservers(buttonType);
            }
        }
        return newValue;
    };
    Object.defineProperty(Xbox360Pad.prototype, "buttonA", {
        /**
         * Gets the value of the `A` button
         */
        get: function () {
            return this._buttonA;
        },
        /**
         * Sets the value of the `A` button
         */
        set: function (value) {
            this._buttonA = this._setButtonValue(value, this._buttonA, Xbox360Button.A);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Xbox360Pad.prototype, "buttonB", {
        /**
         * Gets the value of the `B` button
         */
        get: function () {
            return this._buttonB;
        },
        /**
         * Sets the value of the `B` button
         */
        set: function (value) {
            this._buttonB = this._setButtonValue(value, this._buttonB, Xbox360Button.B);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Xbox360Pad.prototype, "buttonX", {
        /**
         * Gets the value of the `X` button
         */
        get: function () {
            return this._buttonX;
        },
        /**
         * Sets the value of the `X` button
         */
        set: function (value) {
            this._buttonX = this._setButtonValue(value, this._buttonX, Xbox360Button.X);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Xbox360Pad.prototype, "buttonY", {
        /**
         * Gets the value of the `Y` button
         */
        get: function () {
            return this._buttonY;
        },
        /**
         * Sets the value of the `Y` button
         */
        set: function (value) {
            this._buttonY = this._setButtonValue(value, this._buttonY, Xbox360Button.Y);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Xbox360Pad.prototype, "buttonStart", {
        /**
         * Gets the value of the `Start` button
         */
        get: function () {
            return this._buttonStart;
        },
        /**
         * Sets the value of the `Start` button
         */
        set: function (value) {
            this._buttonStart = this._setButtonValue(value, this._buttonStart, Xbox360Button.Start);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Xbox360Pad.prototype, "buttonBack", {
        /**
         * Gets the value of the `Back` button
         */
        get: function () {
            return this._buttonBack;
        },
        /**
         * Sets the value of the `Back` button
         */
        set: function (value) {
            this._buttonBack = this._setButtonValue(value, this._buttonBack, Xbox360Button.Back);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Xbox360Pad.prototype, "buttonLB", {
        /**
         * Gets the value of the `Left` button
         */
        get: function () {
            return this._buttonLB;
        },
        /**
         * Sets the value of the `Left` button
         */
        set: function (value) {
            this._buttonLB = this._setButtonValue(value, this._buttonLB, Xbox360Button.LB);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Xbox360Pad.prototype, "buttonRB", {
        /**
         * Gets the value of the `Right` button
         */
        get: function () {
            return this._buttonRB;
        },
        /**
         * Sets the value of the `Right` button
         */
        set: function (value) {
            this._buttonRB = this._setButtonValue(value, this._buttonRB, Xbox360Button.RB);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Xbox360Pad.prototype, "buttonLeftStick", {
        /**
         * Gets the value of the Left joystick
         */
        get: function () {
            return this._buttonLeftStick;
        },
        /**
         * Sets the value of the Left joystick
         */
        set: function (value) {
            this._buttonLeftStick = this._setButtonValue(value, this._buttonLeftStick, Xbox360Button.LeftStick);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Xbox360Pad.prototype, "buttonRightStick", {
        /**
         * Gets the value of the Right joystick
         */
        get: function () {
            return this._buttonRightStick;
        },
        /**
         * Sets the value of the Right joystick
         */
        set: function (value) {
            this._buttonRightStick = this._setButtonValue(value, this._buttonRightStick, Xbox360Button.RightStick);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Xbox360Pad.prototype, "dPadUp", {
        /**
         * Gets the value of D-pad up
         */
        get: function () {
            return this._dPadUp;
        },
        /**
         * Sets the value of D-pad up
         */
        set: function (value) {
            this._dPadUp = this._setDPadValue(value, this._dPadUp, Xbox360Dpad.Up);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Xbox360Pad.prototype, "dPadDown", {
        /**
         * Gets the value of D-pad down
         */
        get: function () {
            return this._dPadDown;
        },
        /**
         * Sets the value of D-pad down
         */
        set: function (value) {
            this._dPadDown = this._setDPadValue(value, this._dPadDown, Xbox360Dpad.Down);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Xbox360Pad.prototype, "dPadLeft", {
        /**
         * Gets the value of D-pad left
         */
        get: function () {
            return this._dPadLeft;
        },
        /**
         * Sets the value of D-pad left
         */
        set: function (value) {
            this._dPadLeft = this._setDPadValue(value, this._dPadLeft, Xbox360Dpad.Left);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Xbox360Pad.prototype, "dPadRight", {
        /**
         * Gets the value of D-pad right
         */
        get: function () {
            return this._dPadRight;
        },
        /**
         * Sets the value of D-pad right
         */
        set: function (value) {
            this._dPadRight = this._setDPadValue(value, this._dPadRight, Xbox360Dpad.Right);
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Force the gamepad to synchronize with device values
     */
    Xbox360Pad.prototype.update = function () {
        _super.prototype.update.call(this);
        if (this._isXboxOnePad) {
            this.buttonA = this.browserGamepad.buttons[0].value;
            this.buttonB = this.browserGamepad.buttons[1].value;
            this.buttonX = this.browserGamepad.buttons[2].value;
            this.buttonY = this.browserGamepad.buttons[3].value;
            this.buttonLB = this.browserGamepad.buttons[4].value;
            this.buttonRB = this.browserGamepad.buttons[5].value;
            this.leftTrigger = this.browserGamepad.buttons[6].value;
            this.rightTrigger = this.browserGamepad.buttons[7].value;
            this.buttonBack = this.browserGamepad.buttons[8].value;
            this.buttonStart = this.browserGamepad.buttons[9].value;
            this.buttonLeftStick = this.browserGamepad.buttons[10].value;
            this.buttonRightStick = this.browserGamepad.buttons[11].value;
            this.dPadUp = this.browserGamepad.buttons[12].value;
            this.dPadDown = this.browserGamepad.buttons[13].value;
            this.dPadLeft = this.browserGamepad.buttons[14].value;
            this.dPadRight = this.browserGamepad.buttons[15].value;
        }
        else {
            this.buttonA = this.browserGamepad.buttons[0].value;
            this.buttonB = this.browserGamepad.buttons[1].value;
            this.buttonX = this.browserGamepad.buttons[2].value;
            this.buttonY = this.browserGamepad.buttons[3].value;
            this.buttonLB = this.browserGamepad.buttons[4].value;
            this.buttonRB = this.browserGamepad.buttons[5].value;
            this.leftTrigger = this.browserGamepad.buttons[6].value;
            this.rightTrigger = this.browserGamepad.buttons[7].value;
            this.buttonBack = this.browserGamepad.buttons[8].value;
            this.buttonStart = this.browserGamepad.buttons[9].value;
            this.buttonLeftStick = this.browserGamepad.buttons[10].value;
            this.buttonRightStick = this.browserGamepad.buttons[11].value;
            this.dPadUp = this.browserGamepad.buttons[12].value;
            this.dPadDown = this.browserGamepad.buttons[13].value;
            this.dPadLeft = this.browserGamepad.buttons[14].value;
            this.dPadRight = this.browserGamepad.buttons[15].value;
        }
    };
    /**
     * Disposes the gamepad
     */
    Xbox360Pad.prototype.dispose = function () {
        _super.prototype.dispose.call(this);
        this.onButtonDownObservable.clear();
        this.onButtonUpObservable.clear();
        this.onPadDownObservable.clear();
        this.onPadUpObservable.clear();
    };
    return Xbox360Pad;
}(Gamepad));
export { Xbox360Pad };
//# sourceMappingURL=xboxGamepad.js.map